module.exports = __webpack_public_path__ + "static/Net-Iphone-Still-fe925564b7d68a89aff239313fb32d40.jpg";